import styled from 'styled-components';


export const HomeContainer = styled.div`
  background-color:#EBEBEE;
  height:100%;
  
`;
export const FlexBox=styled.div`
  display:flex;
  

  
`
export const HomeImageContainer = styled.div`
  padding-left:200px;
  width:55%;
  background-color:#EBEBEE;
  
`;

export const HomeImage = styled.img`  
mix-blend-mode: multiply; 
`;

export const HomeLoginContainer = styled.div`
padding:20px;
width: 25%;
min-height: 100%;
max-height: 100%;
flex-shrink: 0;
  border-radius: 32px;
background: #FFF;
  
`;

export const LoginHeader = styled.div`
color: #1A1A1A;
font-family: Product Sans;
font-size: 28px;
font-style: normal;
font-weight: 700;
line-height: 32px; /* 114.286% */
padding:25px;

  
`;

export const InputField = styled.div`
margin-top:12px;
margin-left:30px;
display: flex;
flex-direction: row;
width: 80%;
height: 45px;
border: 1px solid #EBEBEE;
align-items: center;
flex-shrink: 0;
border-radius: 12px;
background: #FFF;
box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04);
`;

 
 
 
export const InputBox = styled.input`
padding-left:20px;
width: 100%;
height:55%;
outline:none;
border:none;
color: var(--light-theme-595959, #595959);
font-family: Product Sans;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 24px; /* 150% */

`;



export const EmptyBox = styled.div`
width:100%;
height:80px;
`;
export const LoginButtonContainer = styled.div`
padding-left:36px;
width:80%
`;


export const LoginButton = styled.button`


width:100%;
height: 48px; 
justify-content: center;
align-items: center;


border-radius: 12px;
background: #4285F4;
border:none;
color:#FFFFFF;
outline:none;
cursor: pointer;

color: var(--light-theme-ffffff-100, #FFF);
text-align: center;
font-family: Product Sans;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 24px; /* 150% */
text-transform: uppercase;

`;
